"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const IContainerInjection_1 = require("auto-widget-framework/src/Container/IContainerInjection");
const Mixin_1 = require("auto-widget-framework/src/Util/Mixin");
const Path_1 = require("../Util/Path");
const configs_1 = require("../configs/configs");
class VehicleOptionsRepository {
    constructor(config, httpClient, vehicleOptionsTransformer, errorTransformer) {
        this.config = config;
        this.httpClient = httpClient;
        this.transformer = vehicleOptionsTransformer;
        this.errorTransformer = errorTransformer;
    }
    static create(config, container) {
        return new this(config, container.get('http_client'), container.get('transformer.vehicle_option_to_data'), container.get('transformer.axios_to_error'));
    }
    /**
     * @inheritdoc
     */
    getManufacturers() {
        const url = Path_1.default.route(configs_1.configs.endpoints.vehicleOptions, {});
        return this.httpClient.post(url, {
            "requiredOptions": "manufacturers"
        })
            .catch(err => {
            throw this.errorTransformer.to(err);
        })
            .then((res) => {
            let response = [];
            res.data.items.forEach((option) => {
                response.push(this.transformer.from(option));
            });
            return response;
        });
    }
    /**
     * @inheritdoc
     */
    getModels(id) {
        const url = Path_1.default.route(configs_1.configs.endpoints.vehicleOptions, {});
        return this.httpClient.post(url, {
            "requiredOptions": "models",
            "stepInfo": { "manufacturer": id }
        })
            .catch(err => {
            throw this.errorTransformer.to(err);
        })
            .then((res) => {
            let response = [];
            res.data.items.forEach((option) => {
                response.push(this.transformer.from(option));
            });
            return response;
        });
    }
    /**
     * @inheritdoc
     */
    getTransmissions(manufacturerId, modelId, yearId, body) {
        const url = Path_1.default.route(configs_1.configs.endpoints.vehicleOptions, {});
        return this.httpClient.post(url, {
            "requiredOptions": "transmission_type",
            "stepInfo": { "manufacturer": manufacturerId, "model": modelId, "buildYear": yearId },
            "filters": [{
                    "field": "body_style",
                    "type": "scalar",
                    "values": body,
                }]
        })
            .catch(err => {
            throw this.errorTransformer.to(err);
        })
            .then((res) => {
            let response = [];
            res.data.items.forEach((option) => {
                response.push(this.transformer.from(option));
            });
            return response;
        });
    }
    /**
     * @inheritdoc
     */
    getFuels(manufacturerId, modelId, yearId, body, transmission) {
        const url = Path_1.default.route(configs_1.configs.endpoints.vehicleOptions, {});
        return this.httpClient.post(url, {
            "requiredOptions": "fuel_type",
            "stepInfo": { "manufacturer": manufacturerId, "model": modelId, "buildYear": yearId },
            "filters": [{
                    "field": "body_style",
                    "type": "scalar",
                    "values": body,
                }, {
                    "field": "transmission_type",
                    "type": "scalar",
                    "values": transmission,
                }]
        })
            .catch(err => {
            throw this.errorTransformer.to(err);
        })
            .then((res) => {
            let response = [];
            res.data.items.forEach((option) => {
                response.push(this.transformer.from(option));
            });
            return response;
        });
    }
    /**
     * @inheritdoc
     */
    getBodyTypes(manufacturerId, modelId, yearId) {
        const url = Path_1.default.route(configs_1.configs.endpoints.vehicleOptions, {});
        return this.httpClient.post(url, {
            "requiredOptions": "body_style",
            "stepInfo": { "manufacturer": manufacturerId, "model": modelId, "buildYear": yearId }
        })
            .catch(err => {
            throw this.errorTransformer.to(err);
        })
            .then((res) => {
            let response = [];
            res.data.items.forEach((option) => {
                response.push(this.transformer.from(option));
            });
            return response;
        });
    }
    /**
     * @inheritdoc
     */
    getBuildYears(manufacturerId, modelId) {
        const url = Path_1.default.route(configs_1.configs.endpoints.vehicleOptions, {});
        return this.httpClient.post(url, {
            "requiredOptions": "build_years",
            "stepInfo": { "manufacturer": manufacturerId, "model": modelId }
        })
            .catch(err => {
            throw this.errorTransformer.to(err);
        })
            .then((res) => {
            let response = [];
            res.data.items.forEach((option) => {
                response.push(this.transformer.from(option));
            });
            return response;
        });
    }
    /**
     * @inheritdoc
     * @TODO: Refactor arguments into a query object. Add transformer that creates the request json
     */
    getVariants(manufacturerId, modelId, yearId, body, transmission, fuel) {
        const url = Path_1.default.route(configs_1.configs.endpoints.vehicleOptions, {});
        return this.httpClient.post(url, {
            "requiredOptions": "model_variants",
            "stepInfo": { "manufacturer": manufacturerId, "model": modelId, "buildYear": yearId },
            "filters": [{
                    "field": "fuel_type",
                    "type": "scalar",
                    "values": fuel,
                }, {
                    "field": "body_style",
                    "type": "scalar",
                    "values": body,
                }, {
                    "field": "transmission_type",
                    "type": "scalar",
                    "values": transmission,
                }]
        })
            .catch(err => {
            throw this.errorTransformer.to(err);
        })
            .then((res) => {
            let response = [];
            res.data.items.forEach((option) => {
                response.push(this.transformer.from(option));
            });
            return response;
        });
    }
}
exports.default = VehicleOptionsRepository;
Mixin_1.default(VehicleOptionsRepository, IContainerInjection_1.default);
